// ja日本
export default {
    CustomSelect: {
        '请选择': '選択してください',
    },
    TopNav: {
        '创作者': 'クリエイター',
        '游客': 'ゲスト',
        '请登录后体验完整功能': 'ログインして全機能を体験してください',
        '登录': 'ログイン',
        '免费试用': '無料トライアル',
        '退出登录': 'ログアウト',
        '个人中心': 'マイアカウント',
        '我的视频': 'マイビデオ',
        '额度管理': 'クレジット管理',
        '首页': 'ホーム',
        'AI创作': 'AI制作',
        '多参考': 'マルチ参照',
        '文本视频': 'テキストから動画',
        '图片视频': '画像から動画',
        '文生图': 'テキストから画像',
        '图生图': '画像から画像',
        '会员中心': '会員センター',
        '概览': '概要',
        '我的创作': 'マイ作品',
        '账单管理': '請求書管理',
        '生成任务': '生成タスク',
        '价格': '料金',
        '新闻资讯': 'ニュース',
        '确定要退出登录吗？': 'ログアウトしますか？',
        '提示': 'ヒント',
        '确定': '確定',
        '取消': 'キャンセル',
        '退出成功': 'ログアウトしました',
        '视频展示': '動画展示'
    },
    AiLayout: {
        'AI创作中心': 'AI制作センター',
        '视频生成': '動画生成',
        '图片生成': '画像生成',
        '我的作品': 'マイ作品',
        '我的创作': 'マイ作品',
        '今日剩余额度': '本日の残りクレジット',
        '多参考': 'マルチ参照',
        '文本视频': 'テキストから動画',
        '图片视频': '画像から動画',
        '文生图': 'テキストから画像',
        '图生图': '画像から画像',
    },
    HomeLayout: {
        '下一代AI视频生成平台': '次世代AI動画生成プラットフォーム、アイデアを瞬時に現実に',
        '产品': '製品',
        'AI视频': 'AI動画',
        '价格方案': '料金プラン',
        '新闻资讯': 'ニュース',
        '支持': 'サポート',
        '帮助中心': 'ヘルプセンター',
        'API文档': 'APIドキュメント',
        '常见问题': 'よくある質問',
        '法律': '法務',
        '服务条款': '利用規約',
        '隐私政策': 'プライバシーポリシー',
        '使用协议': '使用契約',
        '版权所有': '著作権所有',
        '客服邮箱': 'サポートメール',
        '复制邮箱': 'メールをコピー',
        '开发中': '開発中、ご期待ください！',
        '链接已复制到剪贴板': 'リンクをクリップボードにコピーしました',
    },
    MyLayout: {
        '创作者': 'クリエイター',
        '退出登录': 'ログアウト',
        '概览': '概要',
        '我的创作': 'マイ作品',
        '会员中心': '会員センター',
        '额度管理': 'クレジット管理',
        '账单管理': '請求書管理',
        '生成任务': '生成タスク',
        '确定要退出登录吗？': 'ログアウトしますか？',
        '提示': 'ヒント',
        '确定': '確定',
        '取消': 'キャンセル',
        '退出成功': 'ログアウトしました'
    },
    Image: {
        "文本生成图片": "テキストから画像",
        "图片生成图片": "画像から画像",
        "用文字描述": "言葉でイメージを説明してください",
        "上传图片素材": "画像素材をアップロード、複数画像生成に対応",
        "图片描述": "画像の説明",
        "描述您想要的图片": "生成したい画像の内容を詳細に説明する（日本語または英語）",
        "提示描述越详细效果越好": "ヒント：説明が詳細であるほど、生成結果が良くなります",
        "图片素材": "画像素材",
        "预览图片": "プレビュー",
        "上传图片": "画像をアップロード",
        "支持格式JPGPNG": "JPG、PNG形式に対応",
        "最多": "最大",
        "张图片": "枚",
        "超过大小限制": "10MB制限を超過",
        "不是图片文件": "有効な画像ファイルではありません",
        "最多上传": "最大アップロード",
        "请先上传图片": "先に画像素材をアップロードしてください",
        "请选择要生成的图片": "生成する画像を選択してください",
        "生成结果": "生成結果",
        "重新生成成功": "再生成成功",
        "模型": "AIモデル",
        "请选择模型": "生成モデルを選択してください",
        "分辨率": "出力解像度",
        "请选择分辨率": "解像度を選択してください",
        "图片比例": "画面アスペクト比",
        "补充描述": "追加説明（オプション）",
        "补充描述提示": "オプション：画像に追加したい効果やスタイルを説明してください",
        "开始绘制": "描画開始",
        "开始生成": "生成開始",
        "生成中": "生成中、しばらくお待ちください...",
        "生成成功": "生成成功",
        "图片生成成功": "画像の生成に成功しました！",
        "作品已保存到我的作品": "作品は「マイ作品」に保存されました",
        "继续创作": "続けて制作",
        "查看作品": "作品を見る",
        "请输入图片描述": "画像の説明を入力してください"
    },
    MyCreation: {
        '我的创作': 'マイ作品',
        '查看和管理您的所有作品': 'すべての作品を表示・管理',
        '预览': 'プレビュー',
        '下载': 'ダウンロード',
        '编辑': '編集',
        '分享': 'シェア',
        '删除': '削除',
        '暂无作品': '作品がありません',
        '去创作': '制作する',
        '确定删除': '削除確認',
        '确定要删除作品': '作品を削除しますか',
        '吗？': '？',
        '此操作不可恢复': 'この操作は元に戻せません、ご注意ください！',
        '取消': 'キャンセル',
        '分享作品': '作品をシェア',
        '复制链接': 'リンクをコピー',
        '全部': 'すべて',
        '视频': '動画',
        '图片': '画像',
        '正在下载:': 'ダウンロード中：',
        '链接已复制到剪贴板': 'リンクをクリップボードにコピーしました',
        '删除成功': '削除しました'
    },
    Video: {
        "文本生成视频": "テキストから動画",
        "图片生成视频": "画像から動画",
        "智能视频生成": "スマート動画生成",
        "输入文字描述": "テキストで説明",
        "上传1-9张图片": "1〜9枚の画像をアップロード",
        "上传图片视频音频": "画像/動画/音声をアップロード",
        "视频描述": "動画の説明",
        "描述您想要的视频场景": "希望する動画シーンを説明",
        "提示": "ヒント",
        "图片素材": "画像素材",
        "最多上传": "最大アップロード",
        "张": "枚",
        "预览": "プレビュー",
        "上传图片": "画像をアップロード",
        "支持格式": "JPG、PNG形式、1ファイル最大10MB、最大",
        "AI": "AIがインテリジェントに融合し、スムーズなトランジション効果を生成します",
        "动态描述": "動きの説明",
        "描述您希望图片如何动起来": "画像の動き方を説明してください",
        "个": "個",
        "上传视频": "動画をアップロード",
        "上传音频": "音声をアップロード",
        "描述您希望视频呈现的效果": "希望する動画の効果を説明してください",
        "模型": "モデル",
        "请选择模型": "モデルを選択してください",
        "分辨率": "解像度",
        "请选择分辨率": "解像度を選択してください",
        "宽高比": "アスペクト比",
        "视频时长": "動画の長さ",
        "生成音频": "音声を生成",
        "开启音效": "効果音を有効にする",
        "静音模式": "ミュートモード",
        "音频提示": "ヒント：アップロードした音声はBGMとして使用されます。音声がアップロードされていない場合は、AIが自動的に音楽を生成します",
        "开始生成": "生成開始",
        "积分": "ポイント",
        "生成中": "生成中",
        "生成成功": "生成成功",
        "视频生成成功！": "動画の生成に成功しました！",
        "作品已保存到": "作品は「マイ作品」に保存されました",
        "继续创作": "続けて制作",
        "查看作品": "作品を見る",
        "视频预览": "動画プレビュー",
        "关闭": "閉じる",
        "下载视频": "動画をダウンロード",
        "您的浏览器不支持视频播放": "お使いのブラウザは動画再生に対応していません",
        "生成进度": "生成進捗",
        "描述": "説明",
        "时长": "長さ",
        "秒": "秒",
        "视频素材": "動画素材",
        "音频素材": "音声素材",
        "双图融合模式": "2枚の画像を融合モード",
        "开始下载视频": "動画のダウンロードを開始",
        "请输入视频描述": "動画の説明を入力してください",
        "请至少上传一张图片": "少なくとも1枚の画像をアップロードしてください",
        "请至少上传一张图片或一个视频": "少なくとも1枚の画像または1つの動画をアップロードしてください",
        "最多只能上传": "最大アップロード",
        "超过": "超過",
        "限制": "制限",
        "不是图片文件": "有効な画像ファイルではありません",
        "不是视频文件": "有効な動画ファイルではありません",
        "不是音频文件": "有効な音声ファイルではありません"
    },
    Forgot: {
        "找回密码": "パスワードを再設定",
        "请输入您的邮箱，我们将发送验证码": "メールアドレスを入力してください。認証コードを送信します",
        "密码重置成功，请使用新密码登录": "パスワードを再設定しました。新しいパスワードでログインしてください",
        "密码重置成功": "パスワードを再設定しました",
        "您的密码已成功重置，请使用新密码登录": "パスワードの再設定に成功しました。新しいパスワードでログインしてください",
        "立即登录": "すぐにログイン",
        "邮箱": "メールアドレス",
        "请输入注册邮箱": "登録済みのメールアドレスを入力してください",
        "发送验证码": "認証コードを送信",
        "请输入验证码": "認証コードを入力してください",
        "验证码": "認証コード",
        "新密码": "新しいパスワード",
        "设置新密码": "新しいパスワードを設定",
        "确认新密码": "新しいパスワードを確認",
        "再次输入新密码": "新しいパスワードを再度入力",
        "重置密码": "パスワードを再設定",
        "返回登录": "ログインに戻る",
        "验证中": "認証中",
        "重置中": "再設定中",
        "弱": "弱い",
        "中": "中程度",
        "强": "強い",
        "请输入邮箱地址": "メールアドレスを入力してください",
        "请输入正确的邮箱格式": "正しいメール形式を入力してください",
        "验证码应为6位数字": "認証コードは6桁の数字である必要があります",
        "请输入新密码": "新しいパスワードを入力してください",
        "密码至少需要6位": "パスワードは6文字以上必要です",
        "请再次输入新密码": "新しいパスワードを再度入力してください",
        "两次输入的密码不一致": "入力されたパスワードが一致しません",
        "验证码已发送": "認証コードを送信しました"
    },
    Login: {
        "下一代AI视频生成平台": "次世代AI動画生成プラットフォーム",
        "一键生成": "ワンクリック生成",
        "支持4K超高清输出": "4K超高画質出力対応",
        "多种风格模板任选": "多彩なスタイルテンプレート",
        "商用授权无忧使用": "商用ライセンス、安心してご利用いただけます",
        "欢迎回来": "おかえりなさい",
        "登录您的账号继续创作": "ログインして制作を続ける",
        "邮箱": "メールアドレス",
        "请输入邮箱地址": "メールアドレスを入力してください",
        "密码": "パスワード",
        "请输入您的密码": "パスワードを入力してください",
        "记住我": "次回から自動ログイン",
        "忘记密码？": "パスワードをお忘れですか？",
        "登录": "ログイン",
        "登录中": "ログイン中",
        "还没有账号？": "まだアカウントをお持ちでない場合",
        "立即注册": "今すぐ登録",
        "请输入正确的邮箱格式": "正しいメール形式を入力してください",
        "请输入密码": "パスワードを入力してください",
        "密码至少需要6位": "パスワードは6文字以上必要です",
        "密码不能超过20位": "パスワードは20文字を超えることはできません",
        "登录成功": "ログインしました"
    },
    Register: {
        "创建账号": "アカウント作成",
        "开始您的AI视频创作之旅": "AI動画制作の旅を始めましょう",
        "姓名": "名前",
        "请输入您的姓名": "お名前を入力してください",
        "邮箱": "メールアドレス",
        "请输入邮箱地址": "メールアドレスを入力してください",
        "获取验证码": "認証コードを取得",
        "验证码": "認証コード",
        "请输入验证码": "認証コードを入力してください",
        "密码": "パスワード",
        "设置密码": "パスワードを設定",
        "确认密码": "パスワードを確認",
        "再次输入密码": "パスワードを再入力",
        "我已阅读并同意": "以下の内容を読み、同意します",
        "服务条款": "利用規約",
        "和": "および",
        "隐私政策": "プライバシーポリシー",
        "注册中": "登録中",
        "已有账号？": "すでにアカウントをお持ちですか？",
        "立即登录": "すぐにログイン",
        "弱": "弱い",
        "中": "中程度",
        "强": "強い",
        "请输入姓名": "名前を入力してください",
        "姓名至少需要2个字符": "名前は2文字以上必要です",
        "姓名不能超过20个字符": "名前は20文字を超えることはできません",
        "请输入正确的邮箱格式": "正しいメール形式を入力してください",
        "验证码应为6位数字": "認証コードは6桁の数字である必要があります",
        "请输入密码": "パスワードを入力してください",
        "密码至少需要6位": "パスワードは6文字以上必要です",
        "密码不能超过20位": "パスワードは20文字を超えることはできません",
        "请再次输入密码": "パスワードを再入力してください",
        "两次输入的密码不一致": "入力されたパスワードが一致しません",
        "验证码已发送": "認証コードを送信しました",
        "注册成功": "登録しました"
    },
    Faq: {
        '常见问题': 'よくある質問',
        '您在使用过程中遇到的问题': 'ご利用中に生じた問題の解決策はこちら',
        '搜索您的问题': '質問を検索...',
        '没有找到相关的问题': '関連する質問が見つかりませんでした',
        '查看全部问题': 'すべての質問を見る',
        '没有找到您想要的答案？': 'お探しの答えが見つかりませんでしたか？',
        '我们的客服团队随时为您提供帮助': 'サポートチームがいつでもお手伝いします',
        '复制客服邮箱': 'サポートメールをコピー',
        '链接已复制到剪贴板': 'リンクをクリップボードにコピーしました'
    },
    Home: {
        '立即订阅': '今すぐ登録',
        'AI视频生成新时代': 'AI動画生成の新時代',
        '用文字创造': '言葉で創造する',
        '无限视频': '無限の動画',
        '让每个人都能成为视频创作者': '誰もが動画クリエイターになれます。テキスト説明を入力するだけで、高品質でユニークなAI動画を生成できます。',
        '免费开始': '無料で始める',
        '观看演示': 'デモを見る',
        'AI生成': 'AI生成',
        'AI视频': 'AI動画',
        '三步轻松生成专业视频': '3つの簡単なステップでプロフェッショナルな動画を生成',
        '输入提示词': 'プロンプトを入力',
        '用文字描述您想要的视频内容': '希望する動画の内容を言葉で説明してください。詳細であるほど効果的です',
        '智能生成': 'スマート生成',
        'AI模型自动理解并创作': 'AIモデルが自動的に理解して創作、数分でレンダリング完了',
        '下载作品': '作品をダウンロード',
        '高清视频生成完成': 'HD動画の生成が完了しました。すぐにダウンロードしてご利用いただけます',
        'AI视频生成': 'AI動画生成',
        '精彩视频': 'テキスト説明を入力すると、AIが素晴らしい動画を生成します',
        '描述您想要的视频场景': '希望する動画シーンを説明してください。例：桜の木の下で遊ぶ子猫、花びらを通して差し込む日差し...',
        '生成中': '生成中...',
        '生成视频': '動画を生成',
        'AI图片': 'AI画像',
        '精美图片': 'テキスト説明を入力すると、AIが素晴らしい画像を生成します',
        '描述您想要的图片场景': '希望する画像シーンを説明してください。例：未来的な都市のスカイライン、ネオンライトがきらめく、サイバーパンクスタイル...',
        '生成图片': '画像を生成',
        '强大功能': '強力な機能',
        '让视频创作变得简单有趣': '動画制作をシンプルで楽しく',
        '案例展示': '事例紹介',
        '来看看用户使用': 'ユーザーが作成した素晴らしい作品を見る',
        '创作的精彩作品': 'ユーザー作品',
        '新闻资讯': 'ニュース',
        '了解': '最新情報を見る',
        '的最新动态和产品更新': '最新ニュースと製品アップデート',
        '查看更多': 'もっと見る',
        '热门': '人気',
        '最新': '最新',
        '阅读更多': '続きを読む',
        '选择适合您的方案': 'お客様に合ったプランを選択',
        '灵活的定价': '様々なニーズに対応する柔軟な料金設定',
        '视频预览': '動画プレビュー',
        '生成成功': '生成成功',
        '作品已保存到': '作品は「マイ作品」に保存されました',
        '继续创作': '続けて制作',
        '查看作品': '作品を見る',
        '请输入视频描述': '動画の説明を入力してください',
        '视频生成成功！': '動画の生成に成功しました！',
        '请输入图片描述': '画像の説明を入力してください',
        '图片生成成功！': '画像の生成に成功しました！',
    },
    News: {
        '新闻资讯': 'ニュース',
        '了解': '最新情報を見る',
        '的最新动态和产品更新': '最新ニュースと製品アップデート',
        '精选': '注目',
        '阅读': '読む',
        '点赞': 'いいね',
        '热门': '人気',
        '最新': '最新',
        '阅读更多': '続きを読む',
        '加载中': '読み込み中...',
        '暂无新闻': 'ニュースはありません',
        '清除筛选': 'フィルターをクリア',
        '加载新闻失败': 'ニュースの読み込みに失敗しました。後でもう一度お試しください',
    },
    Price: {
        '选择适合您的方案': 'お客様に合ったプランを選択',
        '灵活的定价': '様々なニーズに対応する柔軟な料金設定',
        '包月': '月額',
        '包年': '年額',
        '购买积分': 'ポイントを購入',
        '只需要几个视频': '数本の動画だけが必要ですか？サブスクリプションなしで、直接ポイントパックを購入',
        '产品大全': '製品カタログ',
        '了解': '詳細を見る',
        '全系列产品的详细信息和支付方式': '全製品シリーズの詳細情報とお支払い方法'
    },
    Billing: {
        '账单管理': '請求書管理',
        '账户余额': 'アカウント残高',
        '本月支出': '今月の支出',
        '订单数量': '注文数',
        '账单列表': '請求書一覧',
        '请选择类型': 'タイプを選択してください',
        '请选择时间范围': '期間を選択してください',
        '订单号': '注文番号',
        '类型': 'タイプ',
        '金额': '金額',
        '状态': 'ステータス',
        '时间': '日時',
        '操作': '操作',
        '查看详情': '詳細を見る',
        '下载发票': '請求書をダウンロード',
        '暂无作品': '作品がありません',
        '去创作': '制作する',
        '支付方式': 'お支払い方法',
        '添加支付方式': '支払い方法を追加',
        '默认': 'デフォルト',
        '设为默认': 'デフォルトに設定',
        '编辑': '編集',
        '删除': '削除',
        '账单详情': '請求書詳細',
        '交易流水号': '取引番号',
        '关闭': '閉じる',
        '账号': '口座番号/カード番号',
        '请输入账号或卡号': '口座番号またはカード番号を入力してください',
        '姓名': '名前',
        '请输入持卡人姓名': 'カード名義人の名前を入力してください',
        '有效期': '有効期限',
        '请输入CVV码': 'CVVコードを入力してください',
        '取消': 'キャンセル',
        '确认添加': '追加を確定',
        '确认修改': '変更を確定',
        '确认删除': '削除を確定',
        '编辑支付方式': '支払い方法を編集',
        '确定要删除支付方式': 'この支払い方法を削除しますか',
        '删除后不可恢复': '削除は元に戻せません、ご注意ください！',
        '请输入账号': '口座番号/カード番号を入力してください',
        '添加成功': '追加しました',
        '修改成功': '変更しました',
        '已设为默认支付方式': 'デフォルトの支払い方法に設定しました',
        '删除成功': '削除しました',
    },
    Credit: {
        '额度管理': 'クレジット管理',
        '当前可用额度': '現在利用可能なクレジット',
        '升级会员': '会員ランクアップ',
        '本月已用': '今月の使用量',
        '视频生成': '動画生成',
        'AI图片': 'AI画像',
        '其他': 'その他',
        '购买额度包': 'クレジットパックを購入',
        '最受欢迎': '一番人気',
        '额度': 'クレジット',
        '立即购买': '今すぐ購入',
        '使用记录': '使用履歴',
        '操作': '操作',
        '类型': 'タイプ',
        '额度变动': 'クレジット変動',
        '时间': '日時',
        '购买': '購入',
        '确认购买': '購入を確定',
        '金额': '金額：',
        '获得': '獲得',
        '取消': 'キャンセル',
        '今天': '今日',
        '昨天': '昨日',
    },
    Dashboard: {
        '欢迎回来': 'おかえりなさい、',
        '创建新视频': '新しい動画を作成',
        '本月生成次数': '今月の生成回数',
        '剩余额度': '残りクレジット',
        '总视频数': '総動画数',
        '会员状态': '会員ステータス',
        '最近生成': '最近の生成',
        '查看全部': 'すべて見る',
        '视频预览': '動画プレビュー',
        '视频生成中': '動画を生成中です。プレビューまでしばらくお待ちください',
    },
    Membership: {
        '会员中心': '会員センター',
        '当前方案': '現在のプラン',
        'Pro 会员': 'Pro会員',
        '专业创作者首选': 'プロクリエイターにおすすめ',
        '月': 'ヶ月',
        '会员有效期': '会員有効期限',
        '剩余天数': '残り日数',
        '续费会员': '更新する',
        '取消订阅': 'サブスクリプションを解約',
        '本月使用情况': '今月の利用状況',
        '视频生成': '動画生成',
        '次': '回',
        '额度使用': 'クレジット使用量',
        '快速生成': '高速生成',
        '升级方案': 'プランアップグレード',
        '联系销售': '営業にお問い合わせ',
        '会员权益': '会員特典',
        '续费后将延长会员有效期30天': '更新すると会員期間が30日間延長されます',
        '取消': 'キャンセル',
        '确认续费': '更新を確定',
        '取消后您将失去所有会员权益': '解約後はすべての会員特典を失いますが、残りのクレジットは保持されます',
        '再想想': '再検討する',
        '确认取消': '解約を確定',
        '姓名': '名前',
        '请输入您的姓名': 'お名前を入力してください',
        '请输入姓名': '名前を入力してください',
        '公司': '会社名',
        '请输入公司名称': '会社名を入力してください',
        '邮箱': 'メールアドレス',
        '请输入邮箱地址': 'メールアドレスを入力してください',
        '请输入邮箱': 'メールアドレスを入力してください',
        '请输入正确的邮箱格式': '正しいメール形式を入力してください',
        '需求': 'ご要望',
        '请描述您的需求': 'ご要望を説明してください',
        '提交': '送信',
        '请填写需求': 'ご要望を入力してください',
        '续费成功': '更新しました！会員期間が延長されました',
        '已取消订阅': 'サブスクリプションを解約しました。有効期限の終了後に会員資格は失効します',
        '提交成功': '送信しました。追ってご連絡いたします。',
    },
    Task: {
        '生成任务': '生成タスク',
        '新建任务': '新しいタスク',
        '进行中': '進行中',
        '已完成': '完了',
        '失败': '失敗',
        '队列中': 'キュー待ち',
        '活跃任务': 'アクティブなタスク',
        '刷新': '更新',
        '暂无活跃任务': 'アクティブなタスクはありません',
        '预计剩余': '予想残り時間',
        '暂停': '一時停止',
        '继续': '再開',
        '取消': 'キャンセル',
        '最近完成': '最近完了したもの',
        '查看全部': 'すべて見る',
        '暂无完成的任务': '完了したタスクはありません',
        '播放': '再生',
        '下载': 'ダウンロード',
        '分享': 'シェア',
        '确认取消': 'キャンセルを確定',
        '确定要取消任务吗': 'タスクをキャンセルしますか？',
        '已消耗的额度将无法退还': '消費されたクレジットは返金されません',
        '返回': '戻る',
        '分享作品': '作品をシェア',
        '复制链接': 'リンクをコピー',
        '任务列表已刷新': 'タスクリストを更新しました',
        '已暂停': '一時停止中',
        '生成中': '生成中',
        '已恢复': '再開しました',
        '任务已取消': 'タスクをキャンセルしました',
        '链接已复制到剪贴板': 'リンクをクリップボードにコピーしました',
    },
    VideoShow: {
        '示例': 'サンプル',
        '来自我们演示库的一套精心挑选的剪辑片段，点击任何卡片即可开始生成与之风格相似的素材。': 'デモライブラリから厳選されたクリップ集。カードをクリックすると、類似スタイルのコンテンツ生成を開始できます。',
        '全部': 'すべて',
        '电影感': '映画のような',
        '角色': 'キャラクター',
        '产品': '製品',
        '自然': '自然',
        '趣味': '楽しい',
        '加载中': '読み込み中',
        '暂无展示': 'デモはありません',
        '视频预览': 'ビデオプレビュー',
    },
    Request: {
        '加载中': '読み込み中...',
        '您已退出登录': 'ログアウトしました。再ログインできます',
        '确认退出': 'ログアウト確認',
        '重新登录': '再ログイン',
        '错误': 'エラー',
        '网络错误': 'ネットワークエラー',
        '下载中': 'ダウンロード中...'
    },
    Other: {
        '剩余额度': '残高',
        '去登录': 'ログインへ',
        '请登录后查看': 'ログインしてご確認ください',
        '任务': 'タスク',
        '可在「生成任务」中查看详情': '、「生成タスク」で詳細を確認できます',
        '查看详情': '詳細を見る',
        '排队中': '待機中',
        '运行中': '実行中',
        '取消': 'キャンセル',
        '成功': '成功',
        '失败': '失敗',
        '超时': 'タイムアウト',
        '最后更新': '最終更新：',
        '视频生成': '動画生成',
        '活跃用户': 'アクティブユーザー',
        '用户评分': 'ユーザー評価',
        '万': '万',
        '快速生成': '高速生成',
        '先进的AI模型': '最先端のAIモデルで、数分で高品質な動画を生成',
        '多种风格': '多彩なスタイル',
        '多种风格任您选择': 'リアル、アニメ、アートなど、お好みのスタイルをお選びください',
        '高清输出': 'HD出力',
        '支持4K超高清视频输出': '4K Ultra HD動画出力に対応、細部までくっきり',
        '商用授权': '商用ライセンス',
        '生成的视频可用于商业用途': '生成された動画は商用利用可能、著作権の心配はありません',
        '原价': '定価',
        '积分价格说明': 'ポイント価格の説明',
        '系列': 'シリーズ',
        '模型': 'モデル',
        '分辨率': '解像度',
        '积分': 'ポイント',
        '秒': '秒',
        '秒示例': '秒（例）',
        '图片模型': '画像モデル',
        '图片为': '画像は',
        '系列产品': 'シリーズ製品、現在対応しているのは',
        '支持使用任意机型查看完整体验': '、任意の端末で完全な体験をご覧いただけます。',
        '计费方式': '課金方式',
        '张': '枚',
        '按生成张数计费': '生成枚数で課金',
        '普通用户': '一般ユーザー',
        '无记录': '記録なし',
        '总支出': '総支出',
        '月总使用': '月間総使用',
        '月视频使用': '月間動画使用',
        '月图片使用': '月間画像使用',
        '生成成功': '生成成功',
        '视频总生成': '動画総生成数',
        '图片总生成': '画像総生成数',
        '生成中': '生成中です。1〜3分お待ちください',
        '来自我们演示库的一套精心挑选的剪辑片段': 'デモライブラリから厳選されたクリップ集です。',
        '最近7天': '過去7日間',
        '最近30天': '過去30日間',
        '本月': '今月',
        '上月': '先月',
    }
}